/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { Global, jsx } from '@emotion/react';
import { tableStyles } from './common-styles';
export var GlobalStylesWrapper = function GlobalStylesWrapper(_ref) {
  var featureFlags = _ref.featureFlags;
  return jsx(Global, {
    styles: tableStyles({
      featureFlags: featureFlags
    })
  });
};